<script setup>
// §8.3 BulkActionBar — appears on selection. Bulk approve (Approver Workspace),
// confirm-all-empty-days (Home). Floats (elevation is allowed — it is not a card).
defineProps({
  count: { type: Number, default: 0 },
  noun: { type: String, default: 'day' }, // firm-configurable term (§9)
})
defineEmits(['clear'])
</script>

<template>
  <transition name="bar">
    <div v-if="count > 0" class="l-bulkbar" role="region" aria-label="Bulk actions">
      <div class="count">
        <span class="num n">{{ count }}</span>
        {{ noun }}{{ count === 1 ? '' : 's' }} selected
      </div>
      <div class="sep" aria-hidden="true"></div>
      <div class="acts">
        <slot />
      </div>
      <button class="clear" type="button" @click="$emit('clear')">Clear</button>
    </div>
  </transition>
</template>

<style scoped>
.l-bulkbar {
  position: sticky;
  bottom: var(--sp-5);
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-3) var(--sp-3) var(--sp-3) var(--sp-5);
  background: var(--brand);
  color: var(--on-emphasis);
  border-radius: var(--r-pill);
  box-shadow: var(--shadow);
  width: fit-content;
  margin: 0 auto;
}
.count {
  font-size: var(--text-sm);
  font-weight: 500;
  color: var(--lotus-primary-200);
}
.count .n {
  color: var(--on-emphasis);
  font-weight: 600;
  margin-right: 2px;
}
.sep {
  width: 1px;
  align-self: stretch;
  background: var(--on-emphasis-line);
}
.acts {
  display: flex;
  gap: var(--sp-2);
}
.clear {
  font-size: var(--text-chip);
  font-weight: 600;
  color: var(--lotus-primary-200);
  padding: 6px 12px;
  min-height: var(--target-min);
  border-radius: var(--r-sm);
  cursor: pointer;
  background: none;
  border: 0;
}
.clear:hover {
  color: var(--on-emphasis);
}
.bar-enter-active,
.bar-leave-active {
  transition: opacity var(--t-fast) var(--ease), transform var(--t-fast) var(--ease);
}
.bar-enter-from,
.bar-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
